module.exports = __webpack_public_path__ + "img/prize-02.195ef804.png";